/* ==========================================================================
   CREATIVE DETONATOR - Test Controller
   Explosion test checklist for method pages
   Location: frontend/js/method/test.js
   ========================================================================== */

const TestController = {
  criteria: [],
  passedCount: 0,
  hasExploded: false,

  init() {
    this.criteria = document.querySelectorAll('.criterion-item');
    this.meterSegments = document.querySelectorAll('.meter-segment');
    this.meterCount = document.querySelector('.meter-count');
    this.resultSection = document.querySelector('.test-result');
    this.quickChecklist = document.querySelectorAll('.checklist-item');

    this.bindEvents();
    this.updateMeter();
  },

  bindEvents() {
    this.criteria.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.toggleCriterion(item, index);
      });
    });
  },

  toggleCriterion(item, index) {
    item.classList.toggle('checked');
    this.playClickSound();

    // Update quick checklist visual state
    if (this.quickChecklist[index]) {
      // We just toggle the class, CSS handles the image visibility
      if (item.classList.contains('checked')) {
        this.quickChecklist[index].classList.add('checked');
      } else {
        this.quickChecklist[index].classList.remove('checked');
      }
    }

    this.updateMeter();
    this.checkComplete();
  },

  updateMeter() {
    const checked = document.querySelectorAll('.criterion-item.checked');
    this.passedCount = checked.length;

    // Update meter segments
    this.meterSegments.forEach((segment, index) => {
      if (index < this.passedCount) {
        segment.classList.add('filled');
      } else {
        segment.classList.remove('filled');
      }
    });

    // Update count display with color states
    if (this.meterCount) {
      this.meterCount.textContent = `${this.passedCount}/8`;
      this.meterCount.classList.remove('warning', 'success');

      if (this.passedCount >= 7) {
        this.meterCount.classList.add('success');
      } else if (this.passedCount >= 4) {
        this.meterCount.classList.add('warning');
      }
    }
  },

  checkComplete() {
    if (this.passedCount === 8 && this.resultSection) {
      this.resultSection.classList.add('pass');
      const status = this.resultSection.querySelector('.result-status');
      const message = this.resultSection.querySelector('.result-message');

      if (status) status.textContent = 'READY TO PRESENT';
      if (message) message.textContent = 'All 8 criteria passed. This idea is ready.';

      // Trigger explosion only once
      if (!this.hasExploded) {
        this.hasExploded = true;
        this.triggerExplosion();
      }
    } else if (this.resultSection) {
      this.resultSection.classList.remove('pass');
      this.hasExploded = false;
      const status = this.resultSection.querySelector('.result-status');
      const message = this.resultSection.querySelector('.result-message');

      if (status) status.textContent = 'INCOMPLETE';
      if (message) message.textContent = `${8 - this.passedCount} criteria remaining.`;
    }
  },

  triggerExplosion() {
    // Play success sound
    this.playSuccessSound();

    // Create explosion overlay
    const overlay = document.createElement('div');
    overlay.className = 'explosion-overlay';
    overlay.innerHTML = '<div class="explosion-text">READY TO<br>PRESENT</div>';
    document.body.appendChild(overlay);

    // Remove after animation
    setTimeout(() => {
      overlay.remove();
    }, 1500);
  },

  playClickSound() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = 440;
      osc.type = 'square';
      gain.gain.value = 0.1;
      osc.start();
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.05);
      osc.stop(ctx.currentTime + 0.05);
    } catch(e) {}
  },

  playSuccessSound() {
    try {
      const ctx = new (window.AudioContext || window.webkitAudioContext)();
      // Explosion-like sound
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.frequency.value = 150;
      osc.type = 'sawtooth';
      gain.gain.value = 0.2;
      osc.start();
      osc.frequency.exponentialRampToValueAtTime(50, ctx.currentTime + 0.3);
      gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + 0.4);
      osc.stop(ctx.currentTime + 0.4);

      // Victory chime after
      setTimeout(() => {
        const notes = [523, 659, 784, 1047]; // C5, E5, G5, C6
        notes.forEach((freq, i) => {
          const osc2 = ctx.createOscillator();
          const gain2 = ctx.createGain();
          osc2.connect(gain2);
          gain2.connect(ctx.destination);
          osc2.frequency.value = freq;
          osc2.type = 'square';
          gain2.gain.value = 0.08;
          osc2.start(ctx.currentTime + i * 0.1);
          gain2.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + i * 0.1 + 0.2);
          osc2.stop(ctx.currentTime + i * 0.1 + 0.2);
        });
      }, 400);
    } catch(e) {}
  }
};

// Auto-init when DOM ready and page type matches
document.addEventListener('DOMContentLoaded', () => {
  if (document.body.dataset.methodPage === 'test') {
    TestController.init();
  }
});

// Export for external use
window.TestController = TestController;
